import { toast } from "sonner";
import { errText, downloadFile } from "../../../lib/api";
import { FilePdf, Trash, CheckCircle } from "@phosphor-icons/react";

const Row = ({ label, value, bold }) => (
  <div className={`flex justify-between text-sm py-1.5 ${bold ? "font-bold" : ""}`}>
    <span className={bold ? "" : "text-stone-600"}>{label}</span>
    <span className="tabular-nums">₹{(Number(value) === 0 ? 0 : Number(value)).toLocaleString("en-IN")}</span>
  </div>
);

export const FnfCard = ({ f, onSettle, onDelete }) => (
  <div className="bg-white border border-stone-200 rounded-lg p-6 space-y-3" data-testid={`fnf-card-${f.id}`}>
    <div className="flex items-start justify-between gap-3">
      <div>
        <div className="font-heading font-bold">{f.employee_name}</div>
        <div className="text-xs text-stone-500">{f.employee_code} · {f.designation} · LWD {f.last_working_day} · {f.tenure_years} yrs</div>
      </div>
      <span className={`text-xs font-bold px-3 py-1.5 rounded-full ${f.status === "settled" ? "bg-green-50 text-green-700" : "bg-amber-50 text-amber-700"}`} data-testid={`fnf-status-${f.id}`}>{f.status}</span>
    </div>
    <div className="border-t border-stone-100 pt-2">
      <Row label={`Final month salary (${f.worked_days}/${f.days_in_month} days)`} value={f.prorated_salary} />
      <Row label={`Leave encashment (${f.el_balance} EL days)`} value={f.leave_encashment} />
      <Row label={f.gratuity > 0 ? `Gratuity (${f.completed_years} completed yrs)` : "Gratuity"} value={f.gratuity} />
      <Row label="PF" value={-f.pf} />
      <Row label="ESIC" value={-f.esic} />
      <Row label="TDS" value={-f.tds} />
      <div className="border-t border-stone-200 mt-1">
        <Row label="Net payable" value={f.net_payable} bold />
      </div>
    </div>
    {f.remarks && <p className="text-xs text-stone-500">Remarks: {f.remarks}</p>}
    <div className="flex flex-wrap gap-2 pt-1">
      <button onClick={() => downloadFile(`/fnf/${f.id}/pdf`, `fnf_${f.employee_code}.pdf`).catch((e) => toast.error(errText(e)))}
        data-testid={`fnf-pdf-${f.id}`}
        className="tap-scale flex items-center gap-2 px-4 py-2.5 rounded-full bg-secondary text-white text-sm font-bold hover:bg-[#1E2B22] transition-colors duration-200">
        <FilePdf size={16} /> Statement PDF
      </button>
      {f.status === "draft" && (
        <>
          <button onClick={() => onSettle(f.id)} data-testid={`fnf-settle-${f.id}`}
            className="tap-scale flex items-center gap-2 px-4 py-2.5 rounded-full bg-green-700 text-white text-sm font-bold hover:bg-green-800 transition-colors duration-200">
            <CheckCircle size={16} /> Mark settled
          </button>
          <button onClick={() => onDelete(f.id)} data-testid={`fnf-delete-${f.id}`}
            className="tap-scale flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-stone-300 text-stone-700 text-sm font-bold hover:bg-stone-50 transition-colors duration-200">
            <Trash size={16} /> Delete draft
          </button>
        </>
      )}
    </div>
  </div>
);
